<template>
  <div class="swiper-container" id="nav">
    <div class="swiper-wrapper">
      <div class="swiper-slide nav-item" v-first.once="index" v-for="(nav,index) in navs" @click="goToRecommend(nav)">
        <div class="nav-item-head">
          <div class="nav-item-head-head">{{nav.title}}</div>
          <div class="nav-item-head-foot">{{nav.dTitle}}</div>
        </div>
        <div class="nav-item-foot">
          <img :src="cdn+nav.path"/>
        </div>

      </div>
    </div>
    <!-- Add Scrollbar -->
    <!--<div class="swiper-scrollbar"></div>-->
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.min.css';
  import Swiper from 'swiper/dist/js/swiper.min.js';
  export default{
    name:'navRecommend',
    props:['navs','cdn'],
    data(){
      return {
      }
    },
    created(){
      console.log(this.navs);
    },
    watch:{

    },
    directives: {
      first: {
        bind: function (el, binding, vnode) {
          if(binding.value==0){
            el.style='border-left:#f0f0f0 solid 1px';
          }
        }
      }
    },
    mounted(){
      new Swiper('#nav', {
//        scrollbar: '.swiper-scrollbar',
        slidesPerView: 'auto',
        scrollbarHide: true,
        grabCursor: true
      });
    },
    methods:{
      goToRecommend(nav){
        this.jumpToView(this.headType.recommend,"sorting="+nav.idx+"&tcid=0&k="+nav.key,nav.title)
      }
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// NavRecommend.vue?780fc118